module.exports = __webpack_public_path__ + "static/media/23_r_ugol_80.94_0.b42157b1.png";